import React, { FC } from 'react';
import * as S from './Scoreboard.style';
import { usePlayers } from '../../context/PlayerContext';
import { useGame } from '../../context/GameContext';
import { avatars } from 'utils/avatars';

export const DartsScoreboard: FC = () => {
  const { players } = usePlayers();
  const {
    currentTurn,
    gameSettings: { target },
  } = useGame();

  return (
    <S.TableContainer>
      <S.Table aria-label="Darts Scoreboard">
        <S.TableHead>
          <S.TableRow>
            <S.TableCell>Player</S.TableCell>
            <S.TableCell align="center">Zbývá do cíle</S.TableCell>
          </S.TableRow>
        </S.TableHead>
        <S.TableBody>
          {players.map((player, playerIndex) => {
            const used = (player.scores ?? []).reduce<number>(
              (sum, score) => sum + (score ?? 0),
              0
            );
            const remaining = Math.max(0, (target ?? 0) - used);

            return (
              <S.TableRow
                key={playerIndex}
                disabled={!player.isActive}
                activeRow={playerIndex === currentTurn}
              >
                <S.TableCell component="th">
                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      fontWeight: '600',
                    }}
                  >
                    <img
                      src={avatars[playerIndex] ?? avatars[avatars.length - 1]}
                      alt={`avatar-${playerIndex}`}
                      style={{
                        width: 25,
                        height: 25,
                        borderRadius: '50%',
                        marginRight: 8,
                      }}
                    />
                    <span>{player.player}</span>
                  </div>
                </S.TableCell>
                <S.TableCell
                  align="center"
                  style={{ fontWeight: '600', fontSize: 16 }}
                >
                  {remaining}
                </S.TableCell>
              </S.TableRow>
            );
          })}
        </S.TableBody>
      </S.Table>
    </S.TableContainer>
  );
};
